module.exports = __webpack_public_path__ + "img/procnodata.9da0b922.svg";